import { Box, Stack } from "@braintrust/braintrust-ui-components";
import type { ProfileCompletionAreaData } from "@js/apps/freelancer/hooks/use-current-freelancer-profile-completion";

import {
  ProfileCompletionFeedbackLabel,
  profileCompletionFeedbackLabelPropMap,
} from "./labels";

export type ProfileCompletionFeedbackProps = {
  missingAreas: ProfileCompletionAreaData[];
  className?: string;
};

export const ProfileCompletionFeedback = ({
  missingAreas = [],
}: ProfileCompletionFeedbackProps) => {
  if (missingAreas.length === 0) {
    return null;
  }

  return (
    <Stack component="ul" className={"list-reset"}>
      {missingAreas.map((item) => {
        const props = profileCompletionFeedbackLabelPropMap[item.area];

        return (
          <Box
            component="li"
            key={item.area}
            sx={{ m: 0, color: "var(--white)" }}
          >
            <ProfileCompletionFeedbackLabel
              {...props}
              number={item.itemsCount}
              progress={item.progress}
            />
          </Box>
        );
      })}
    </Stack>
  );
};
